import { render, staticRenderFns } from "./activityDeclarationSettings.vue?vue&type=template&id=1af62eae&scoped=true"
import script from "./activityDeclarationSettings.vue?vue&type=script&lang=js"
export * from "./activityDeclarationSettings.vue?vue&type=script&lang=js"
import style0 from "./activityDeclarationSettings.vue?vue&type=style&index=0&id=1af62eae&prod&scoped=true&lang=scss"
import style1 from "./activityDeclarationSettings.vue?vue&type=style&index=1&id=1af62eae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af62eae",
  null
  
)

export default component.exports